import React from "react";
import PropTypes from "prop-types";
import { formatWhen } from "../utils/format";

// A list date such as "Yesterday, 11:23 AM". In a narrow column it breaks
// between the day and the time, never inside either.
const part = { display: "inline-block", whiteSpace: "nowrap" };

const WhenText = ({ dateTime }) => {
  const text = formatWhen(dateTime);
  const cut = text.lastIndexOf(", ");
  if (cut === -1) return <span style={part}>{text}</span>;
  return (
    <span>
      <span style={part}>{text.slice(0, cut + 1)}</span>{" "}
      <span style={part}>{text.slice(cut + 2)}</span>
    </span>
  );
};

WhenText.propTypes = {
  dateTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
};

export default WhenText;
